import LogoFile from '../assets/gsm_logo.png';

export function GSMLogo({width='30%'}){
    return (
        <div style={{padding: 8,width}}>
            <img src={LogoFile} alt={'logo'} width={'100%'} height={'auto'}/>
        </div>
    )
}